import React from 'react';

import { Rating } from '@sbi-international/boutik.gatsby.plugin.components';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { ProductReviewsResume } from '../../models/productReviewsResume';


type ProductTitleProps = {
    reviews?: ProductReviewsResume;
    product: any;
};

export function ProductTitle(props: ProductTitleProps) {
    const { reviews, product } = props;
    const { currentLocale } = usePageLocalization();

    return (
        <React.Fragment>
            <h3>{product.title[currentLocale]}</h3>
            
            <div>
                {reviews && reviews?.count > 0 && (
                    <Rating.RatingScore
                        ratingScore={reviews?.average as number}
                        ratingCount={reviews?.count}
                    />
                )}
            </div>
        </React.Fragment>
    );
}
